import { render, staticRenderFns } from "./LabItemAnalisis.vue?vue&type=template&id=391b1dd9&"
import script from "./LabItemAnalisis.vue?vue&type=script&lang=js&"
export * from "./LabItemAnalisis.vue?vue&type=script&lang=js&"
import style0 from "./LabItemAnalisis.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports